import { sectionSortMethod_Alphabet, sectionSortMethod_Static, sectionSortMethod_Timestamp } from './types.js';
export const sectionSortMethod_LabelMap = {
    [sectionSortMethod_Static]: 'Static',
    [sectionSortMethod_Alphabet]: 'Alphabet',
    [sectionSortMethod_Timestamp]: 'Timestamp',
};
export const sectionSortMethod_InfoMap = {
    [sectionSortMethod_Static]: 'Items are kept in the order they are gotten.',
    [sectionSortMethod_Alphabet]: 'Items are sorted alphabetically.',
    [sectionSortMethod_Timestamp]: 'Items are sorted based on timestamp, newer items first.'
};
//# sourceMappingURL=consts.js.map